import styled from 'styled-components';

import { grey4 } from 'approot/shared/styles/colours.style';
import { rem } from 'approot/shared/style';
import { PrimaryButton } from 'approot/shared/styles/buttons/primary-button.style';

export const MultipleChoiceStudentCheckAnswerDivider = styled.div`
  background-color: ${grey4};
  height: 100%;
  width: ${rem(1)};
`;

export const MultipleChoiceStudentCheckAnswerButton = styled(PrimaryButton)`
  border-radius: ${rem(50)};
`;
